import axios, { AxiosError } from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});
 const fetchUserData = async (token: any) => {
    if (token) {
  
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
  
        },
      };
      try {
        const response = await apiService.get('/user', config);
       

        return response.data;
        
      } catch (error:any) {
        throw error;
      }
    } else {
      return null;
    }
  };

  const updateProfile = async (token: string | null, payload: any) => {
    try {
      if (token) {
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
  
        const response = await apiService.post("/edit-user-profile", payload, config);
        return response.data;
      } 
      
    } catch (error) {
      return error;
    }
  };
  export{fetchUserData,updateProfile}